import { RGuideBrowse } from "@/modules/Guide/browse/RGuideBrowse";
import { RGuideTemplate } from "@/modules/Guide/template/RGuideTemplate";
import { RouteConfig } from "vue-router";

export const REmployeeGuide: RouteConfig = {
  path: "guide",
  component: () =>
    import(
      /* webpackChunkName: "employee-guide" */
      "./VEmployeeGuide.vue"
    ),
  meta: {
    title: "Guide",
    icon: "book-outline",
    newIcon: "book",
  },
  children: [RGuideBrowse, RGuideTemplate],
};
